var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"6be7941d693d6dd0f7a33e0d0e1aa7064f5633a1"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web-app@groove"]={id:"6be7941d693d6dd0f7a33e0d0e1aa7064f5633a1"};
      